"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OFFSET_CLASSES = exports.SIZE_CLASSES = exports.SCREEN_SIZES = exports.SIZE_RANGE = exports.OFFSET_RANGE = exports.MIN_SIZE = exports.MIN_OFFSET = exports.MAX_SIZE = exports.MAX_OFFSET = void 0;

var _range = _interopRequireDefault(require("../utils/underscore/range"));

var MAX_OFFSET = 12;
exports.MAX_OFFSET = MAX_OFFSET;
var MAX_SIZE = 12;
exports.MAX_SIZE = MAX_SIZE;
var MIN_OFFSET = 0;
exports.MIN_OFFSET = MIN_OFFSET;
var MIN_SIZE = 1;
exports.MIN_SIZE = MIN_SIZE;
var OFFSET_RANGE = (0, _range.default)(MIN_OFFSET, MAX_OFFSET + 1);
exports.OFFSET_RANGE = OFFSET_RANGE;
var SIZE_RANGE = (0, _range.default)(MIN_SIZE, MAX_SIZE + 1);
exports.SIZE_RANGE = SIZE_RANGE;
var SCREEN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
exports.SCREEN_SIZES = SCREEN_SIZES;

function createSizeClasses(screenSize) {
  var classes = {};

  for (var i = MIN_OFFSET; i <= MAX_SIZE; i++) {
    if (i === 0) {
      classes[i] = '';
    } else {
      classes[i] = "col-" + screenSize + "-" + i;
    }
  }

  return classes;
}

function createAllSizeClasses() {
  var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var holdScreenClasses = {};
  SCREEN_SIZES.forEach(function (screenSize) {
    holdScreenClasses[screenSize] = createSizeClasses("" + screenSize + append);
  });
  return holdScreenClasses;
}

var SIZE_CLASSES = createAllSizeClasses();
exports.SIZE_CLASSES = SIZE_CLASSES;
var OFFSET_CLASSES = createAllSizeClasses('-offset');
exports.OFFSET_CLASSES = OFFSET_CLASSES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/grid/UIGridConstants.js
// module id = 686
// module chunks = 209 210 211 212